import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function HexagonIcon(props: IconProps) {
    return <Icon {...props} iconKey={"hexagon"}/>
}
